import { createClient, type Client } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import type { ServiceType } from "@bufbuild/protobuf";
import config from "config";
import { KAS_TOKEN_STORAGE_KEY } from "./kas/utils";

const transport = createConnectTransport({
  baseUrl: config.devplaneApiUrl,
  interceptors: [
    (next) => (req) => {
      const token = localStorage.getItem(KAS_TOKEN_STORAGE_KEY);
      if (token) {
        req.header.set("Authorization", `Bearer ${token}`);
      }
      return next(req);
    },
  ],
});

export function createConnectClient<T extends ServiceType>(
  service: T,
): Client<T> {
  return createClient(service, transport);
}
